// Gets the window for the given object.
export function getWindow(object: Element | EventTarget | null): Window | undefined {
  if (!object || !('ownerDocument' in object))
    return undefined;

  // This is null on a Node if it is the document itself, but it shouldn't be null on an Element.
  const element = object as Element;
  const {ownerDocument} = element;
  if (!ownerDocument)
    return undefined;

  // This is null if the document does not have a "browsing context", a situation we don't care about.
  const {defaultView} = ownerDocument;
  if (!defaultView)
    return undefined;

  return defaultView;
}

export function getElementVisibility(element: HTMLElement) {
  if (!element)
    return {isVisible: false, visibilityRatio: 0};

  return new Promise<{isVisible: boolean; visibilityRatio: number}>(resolve => {
    const o = new IntersectionObserver(([entry]) => {
      const visibilityRatio = entry.intersectionRatio;
      resolve({isVisible: visibilityRatio > 0, visibilityRatio});
      o.disconnect();
    });
    o.observe(element);
  });
}

const fallbackCopyTextToClipboard = (text: string) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
};

export const copyToClipboard = (text: string) => {
  if (!text)
    return;
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);

    return;
  }
  navigator.clipboard.writeText(text);
};
